
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HotelForm from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HotelForm />
  </React.StrictMode>
);
